import Skeleton from 'react-loading-skeleton'

const YieldDTFSkeleton = () => (
  <Skeleton count={3} height={320} style={{ marginBottom: 20 }} />
)

export default YieldDTFSkeleton
